import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';
import { PlanShape }   from '@models/map/dxfTypes';

/**
 * Opération custom `POST /imports/{id}/plan/shapes` : TOUTES les formes importables du plan,
 * en vecteur, pour l'aperçu global de l'étape « calques à importer ».
 *
 * Appel : `setId(importId).save({ method: 'post', patchAttributes: { layers } })` — `layers`
 * facultatif (tous les calques par défaut, le filtre n'étant qu'une économie de volume, jamais
 * une règle métier : les rangs sont établis par calque et ne bougent pas).
 *
 * Les coordonnées sont en PIXELS de l'aperçu de `/plan/source` : le fond et les formes se
 * superposent donc par construction, sans calage.
 */
@doc.path('/imports/{id}/plan/shapes')
export default class PlanShapesModel extends MapServiceModel {
	@doc.json   declare shapes: PlanShape[];
	@doc.number declare width: number;
	@doc.number declare height: number;
}
